news11.vue<template>
<div>
		<sub-header bizCd="10"/>
	 	<div class="sub_visual sub10">
            <div class="container">
                <div class="sub_txt">
                    <div class="tit">보도자료</div>
                    <div class="comment">언론에 소개된 에듀윌의 다양한 소식을 만나보세요.</div>
                </div>
            </div>
        </div>
        <div class="contents aos-all">
            <div class="container">
                <div class="sec">
                    <h3>보도자료</h3>
                    <div class="board">
                        <div class="board_header">
                            <h4>에듀윌, 케어런츠·한국요양보호협회와 맞손… 프리미엄 요양보호사 양성 나선다!</h4>
                            <div class="board_meta">
<!--                                <ul>-->
<!--                                    <li>등록일 : 22.05.24</li>-->
<!--                                    <li>조회수 : 142</li>-->
<!--                                </ul>-->
                            </div>
                        </div>
                      <div class="board_body">
                            <div class="board_content">
                              <h2><span style="font-family:'맑은 고딕';"><strong>에듀윌,&nbsp;케어런츠·한국요양보호협회와 맞손…&nbsp;프리미엄 요양보호사 양성 나선다!</strong></span>
                              </h2>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';"><strong>-&nbsp;요양보호사 및 장기요양기관 실무자 역량 강화 위한 업무협약 체결</strong></span>
                              </p>
                              <p><span style="font-family:'맑은 고딕';"><strong>-&nbsp;시니어 케어 산업 발전 및 돌봄 인력 부족 문제 해결에 기여</strong></span>
                              </p>
                              <p>&nbsp;</p>
                              <figure class="image"><img src="//company.eduwill.net/contents/img/20250605131634.jpg"></figure>
                              <p><span style="font-family:'맑은 고딕';">▲사진설명:&nbsp;왼쪽부터 박한식 한국요양보호협회장,&nbsp;양형남 에듀윌 대표,&nbsp;박지성 케어런츠 대표가 업무 협약서에 서명 후 기념촬영을 하고 있다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';"><strong>(2025-02-13) </strong>종합교육기업 ㈜에듀윌(대표 양형남)이 지난 12일,&nbsp;서울 구로동 본사에서 ㈜케어런츠(대표 박지성),&nbsp;한국요양보호협회(회장 박한식)와 함께 요양보호사 및 장기요양기관 실무자 역량 강화를 위한 업무협약(MOU)을 체결했다고 13일 밝혔다.&nbsp;</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">이번 협약식에는 양형남 에듀윌 대표와 박지성 케어런츠 대표,&nbsp;박한식 한국요양보호협회장을 비롯한 주요 관계자들이 참석했다.&nbsp;세 기관은 프리미엄 요양보호사 양성을 위해 긴밀히 협력할 것을 약속했다.&nbsp;</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">㈜케어런츠는 요양보호사 역량 강화 및 인증 플랫폼 분야에서의 높은 전문성을 갖춘 기업이며,&nbsp;한국요양보호협회는 요양보호사의 권익 보호와 복지 증진을 위해 힘쓰고 있는 단체로, 17년 이상 요양보호사 및 교?강사 교육 경험을 보유하고 있다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">이번 협약을 통해 3사는 △프리미엄 요양보호사 및 돌봄 전문가 육성을 위한 교육과정 개발 △온라인 학습과 오프라인 실습을 병행한 실무 역량 강화 지원 △요양 교육기관 대상 프리미엄 케어 커리큘럼 개발 및 공급 △이수증 발급을 통한 역량 인증 △요양보호사와 돌봄 대상자 간 최적의 매칭 지원 등을 주요 협력 사항으로 추진한다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">특히,&nbsp;양성된 인력들이 시장에서 합당한 대우를 받을 수 있도록 체계적인 교육 과정을 구축하고,&nbsp;교육 이수 후에는 인증 체계를 마련해 실질적인 경쟁력을 갖춘 전문가로 성장할 수 있도록 지원할 계획이다.&nbsp;또한,&nbsp;요양보호사와 장기요양기관 실무자의 역량 데이터를 기반으로 최적의 매칭을 돕고, 돌봄 서비스의 질을 한층 높이는 데 집중할 예정이다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">에듀윌 관계자는 "이번 협약을 통해 요양보호사 및 장기요양기관 실무자들이 보다 체계적인 교육을 받을 수 있는 기회를 제공할 수 있게 됐다"면서 "시니어 산업의 발전과 돌봄 인력 부족 문제 해결에 기여할 수 있도록 최선을 다하겠다"고 말했다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">한편,&nbsp;에듀윌은 다양한 자격증 교육과정 및 직무 교육을 운영하며 성인 학습자의 커리어 향상을 지원하고 있다.&nbsp;이번 협약을 통해 케어런츠와 한국요양보호협회와의 협력해 시니어 케어 산업의 전문성을 한층 강화해 나갈 계획이다.</span>
                              </p>
                            </div>
                        </div>
                        <div class="board_nav">
                            <ul>

                                <!-- 이전 보도 기사가 있을 경우 -->

                                <li class="prev">
                                    <router-link to="/edu/newsRelease/promotionVideo/news19" data-value="315283">
                                        <strong>이전</strong>
                                        <span>에듀윌, 폭스에듀와 MOU 체결… ‘미래 교육 판도 대변혁 시동’</span>
                                    </router-link>
                                </li>

                                <!-- //이전 보도 기사가 있을 경우 -->

                              <!-- 다음 보도 기사가 있을 경우 -->
                              <li class="next">
                                <router-link to="/edu/newsRelease/promotionVideo/news17" data-value="315283">
                                  <strong>다음</strong>
                                  <span>에듀윌, 라오스 진출 본격화…라오스 산업통상부 차관·속싸이그룹 회장단과 회동</span>
                                </router-link>
                              </li>
                              <!-- //다음 보도 기사가 있을 경우 -->

                            </ul>
                        </div>
                        <div class="board_footer">
                            <div class="button-area">
                                <router-link to="/edu/newsRelease/main" class="lg-btn">
                                목록으로
                                </router-link>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SubHeader from "@/layouts/SubHeader";

export default {
	name: "MainOnlineEdu",
	components: {SubHeader},
	data() {
		return {
			swiper : ""
		}
	},
	
	computed: {
	},
	
	methods: {
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
		
		this.swiper = new Swiper("#vi-role.swiper-container", {
	        loop: true,
	        loopFillGroupWithBlank: true,
	        navigation: {
	          nextEl: ".swiper-button-next",
	          prevEl: ".swiper-button-prev"
	        }
	    });
		
		$(".pa_slider_scroll").simplyScroll({
	        customClass:'vert',
			speed: 5,
	        pauseOnHover : true
	    });
	},
	beforeDestroy() {
	},
	destroyed() {
	}
}
</script>
